export enum PressArticleFormMode {
    Add = 'add',
    Edit = 'edit',
}
